// Angular modules
import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable()
export class DateIntervalUtil
{
  static getArrayOfConsecutiveNumbers(start: number, end: number): number[]
  {
    const array: number[] = [];
    for (let i = start; i < end + 1; i++) {
      array.push(i);
    }
    return array;
  }

  static padWithZero(element): string
  {
    const result = element.toString();
    return result.length === 1 ? result.padStart(2, '0') : result;
  }

  static getDateFormatted(date: Date): string
  {
    return date.getFullYear()
      + '-'
      + DateIntervalUtil.padWithZero(date.getMonth() + 1)
      + '-'
      + DateIntervalUtil.padWithZero(date.getDate());
  }

  static getTimeFormatted(hours: number, minutes: number, seconds: number, timezone: string): string
  {
    return (
      'T' +
      DateIntervalUtil.padWithZero(hours) +
      ':' +
      DateIntervalUtil.padWithZero(minutes) +
      ':' +
      DateIntervalUtil.padWithZero(seconds) +
      timezone.replace(/:/gi, '')
    );
  }

  static getDateAndTimeFormattedToFilter(date: Date, hours: number, minutes: number, seconds: number, timezone: string): string
  {
    return formatDate(
      DateIntervalUtil.getDateFormatted(date) + DateIntervalUtil.getTimeFormatted(hours, minutes, seconds, timezone),
      'yyyy-MM-dd HH:mm:ss',
      'en-US',
      'UTC'
    );
  }

  static getDateAndTimeFormattedToDisplay(date: Date, hours: number, minutes: number, seconds: number, timezone: string): string
  {
    return formatDate(
      DateIntervalUtil.getDateFormatted(date) + DateIntervalUtil.getTimeFormatted(hours, minutes, seconds, timezone),
      'yyyy-MM-dd HH:mm:ssZ',
      'en-US',
      timezone.replace(/:/gi, '')
    );
  }

  static getDateFilter(date: Date, hours: number, minutes: number, seconds: number, timezone: string)
    : { value: string; dateLabel: string }
  {
    const value = DateIntervalUtil.getDateAndTimeFormattedToFilter(date, hours, minutes, seconds, timezone);
    const dateLabel = DateIntervalUtil.getDateAndTimeFormattedToDisplay(date, hours, minutes, seconds, timezone);
    return { value, dateLabel };
  }
}
